var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar-home'),_c('div',[_c('auth-comp',{on:{"success":_vm.success,"fail":_vm.fail}})],1),_c('div',[_c('footer-section')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }